import { Button, ButtonProps } from '@mui/material';
import React, { FC, MouseEvent, ReactNode } from 'react';
import './Button.scss';

interface IButtonProps extends ButtonProps {
    label: string | ReactNode,
    startIcon?: JSX.Element,
    endIcon?: JSX.Element,
    onClick: (e: MouseEvent<Element>) => void,
    disabled?: boolean,
    className?: string
}

const CheckmateButton: FC<IButtonProps> = ({label, variant, onClick, className = "", ...props}) => {
    const iconButton = !label.length && (!!props.startIcon || !!props.endIcon);
    const hasShadow = variant !== 'text';
    return <Button
        className={(hasShadow ? 'shadow-button ' : '' )+(iconButton ? 'icon-button' : '') + " " + className}
        size="medium"
        onClick={onClick}
        variant={variant}
        disableElevation
        {...props}
    >
        {label}
    </Button>
}

export default CheckmateButton;